<template>
    <div class="container pt-5">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <img src="../../assets/img/logo-login.svg" alt="Login">
                <div class="panel">
                    <h3>Wachtwoord vergeten</h3>

                    <p>Kan de beste overkomen. Vul hieronder uw e-mailadres in en klik op "Reset wachtwoord". Indien er een account geregistreerd is met het opgegeven e-mailadres zal er een resetlink verstuurd worden.</p>
                    <form @submit.prevent="requestReset">
                        <div class="form-group">
                            <label>E-mailadres</label>
                            <input type="email" v-model="email" class="form-control">
                        </div>
                        <div class="d-flex">
                            <button
                                class="btn btn--accent ml-auto"
                                :disabled="requestingReset || email.length == 0"
                            >
                                <i class="fa fa-spin fa-circle-o-notch mr-1" v-if="requestingReset"></i>
                                Reset wachtwoord
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            requestingReset: false
        };
    },
    mounted() {},
    methods: {
        requestReset() {
            if (this.requestingReset) {
                return;
            }

            this.requestingReset = true;

            this.$http
                .post("/auth/forgot", {
                    email: this.email
                })
                .then(res => {
                    if (res.data.feedback) {
                        this.$root.$emit("notify", {
                            type: res.data.feedback.type,
                            text: res.data.feedback.message
                        });

                        this.email = "";
                        this.requestingReset = false;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<style lang="scss" scoped>
img {
    display: table;
    margin: 0 auto 30px;
}
.form-control {
    background-color: $subtle;
}
</style>
